// extracted by mini-css-extract-plugin
export default {"section":"Section_section__Skm6R"};